import axios from 'axios'
import Utils from '@/common/Utils'

const url = `${process.env.VUE_APP_BASEPATH}/api`
const headers = { 'Content-Type': 'application/json' }

export default class ZoneService {
    static async getUsersZone (zoneId) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/zones/getUsersByZone/${zoneId}`, { headers })
            return Promise.resolve(data.data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async assignUser (params) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.post(`${url}/zones/assignUser/`, params, { headers })

            return Promise.resolve(data.data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async removeUser (params) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.post(`${url}/zones/removeUser/`, params, { headers })

            return Promise.resolve(data.data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }
}
